import React from "react";

import "./Bubble.scss";

export interface BubbleProps {
  loadLate: boolean;
  isLeft: boolean;
  className?: string;
  children?: any;
  timestamp?: string;
}

export interface BubbleState {
  loaded: boolean;
}

export class Bubble extends React.Component<BubbleProps, BubbleState> {
  constructor(props: BubbleProps) {
    super(props);
    this.state = { loaded: this.props.loadLate ? false : true };
  }
  componentDidMount() {
    if (this.props.loadLate) {
      setTimeout(() => {
        this.loadNow();
      }, 100);
    }
  }
  loadNow() {
    this.setState({ loaded: true });
  }
  render() {
    let className = this.props.isLeft ? "scc-bubble swivl-botBubble" : "scc-bubble swivl-userBubble";
    if (this.props.className) {
      className += " " + this.props.className;
    }
    if (this.props.loadLate) {
      className += " scc-loadLate";
    }
    if (this.state.loaded) {
      className += " scc-loaded";
    }
    return (
      <div className="scc-bubbleGroup">
        <div className={className}>
          <div className="scc-bubbleContent">{this.props.children}</div>
        </div>
        {this.props.timestamp && <div className={"body-2xs text-grey-500" + (this.props.isLeft ? "" : " text-right")}>{this.props.timestamp}</div>}
      </div>
    );
  }
}
